/* stylelint-disable max-nesting-depth */

.uic-multiline-input {
  box-sizing: border-box;
  display: flex;
  flex-flow: column nowrap;
  padding: 2px 8px 8px;
  position: relative;

  &__label {
    color: var(--uic-color-black);
    font-size: var(--uic-font-size-normal);
    line-height: var(--uic-line-height-normal);
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.uic-multiline-input--has-label {
    padding: 2px 8px 8px;

    .uic-multiline-input__label {
      display: block;
      padding-bottom: 4px;
    }
  }

  &__container {
    background: var(--uic-color-white);
    border: 1px solid var(--uic-color-grey2);
    box-sizing: border-box;
    display: flex;
    position: relative;

    &:hover {
      border-color: var(--uic-color-blue2);
      color: var(--uic-color-blue3);
    }

    &:active {
      background: var(--uic-color-blue2a10);
      border: 1px solid var(--uic-color-blue2);
      color: var(--uic-color-blue3);
    }
  }

  &.uic-multiline-input--focused {
    .uic-multiline-input__container {
      color: var(--uic-color-black);
      outline: 2px solid var(--uic-color-blue2);
      outline-offset: -2px;
    }
  }

  &__control {
    --uic-multiline-input-padding-adjustment: calc(
      8px - (var(--uic-line-height-medium) - (var(--uic-multiline-height-of-single-line-input) - 2 * 8px))
    );

    @include font(medium, semibold);
    background: transparent;
    border: 0;
    border-radius: 0;
    box-sizing: border-box;
    caret-color: var(--uic-color-blue2);
    color: inherit;
    display: block;
    flex: 1 1 auto;
    height: 100%;
    margin: 0;
    outline: none;
    padding: var(--uic-multiline-input-padding-adjustment) 8px;
    resize: none;
    width: 100%;

    &::placeholder {
      color: var(--uic-color-grey3a50);
      font-weight: normal;
    }

    &::selection {
      background-color: var(--uic-color-blue2);
      color: var(--uic-color-white);
      line-height: 24px;
    }

    &::selection {
      background-color: var(--uic-color-blue2);
      color: var(--uic-color-white);
    }

    &:disabled::selection {
      background-color: transparent;
      color: inherit;
    }
  }

  &__flag {
    display: none;
    position: absolute;
    right: 4px;
    top: 2px;
  }

  &__helper-text {
    color: var(--uic-color-black);
    font-size: 0.8rem;
    line-height: 1.3rem;
    overflow: hidden;
    text-overflow: ellipsis;

    &-inner {
      @include truncate();
    }
  }

  &.uic-multiline-input--has-helper-text {
    padding-bottom: 1px;

    .uic-multiline-input__helper-text {
      margin-top: 3px;
    }
  }

  &--invalid {
    .uic-multiline-input {
      &__helper-text {
        color: var(--uic-color-red1);
      }
    }
  }

  &--flag {
    .uic-multiline-input {
      &__flag {
        display: block;
      }

      &__control {
        padding-right: 44px;
      }
    }
  }

  &--disabled {
    pointer-events: none;

    .uic-multiline-input__control {
      background-color: var(--uic-color-white);
      border-color: var(--uic-color-grey2a25);
      color: var(--uic-color-blacka50);
      font-weight: var(--uic-font-weight-normal);
    }
  }
}

@media #{$breakpoint_tablet} {
  .uic-multiline-input {
    --uic-multiline-height-of-single-line-input: 40px;
  }
}

@media #{$breakpoint_desktop} {
  .uic-multiline-input {
    --uic-multiline-height-of-single-line-input: 48px;
  }
}

@media #{$breakpoint_tablet_small} {
  .uic-multiline-input {
    --uic-multiline-height-of-single-line-input: 30px;
  }
}
